import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import CardContent from "@material-ui/core/CardContent";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles({
  main: {
    "&:last-child": {
      paddingBottom: 0
    }
  },
  cardsText: {
    color: "rgb(255,255,255)",
    fontFamily: "Roboto",
    fontSize: "22px",
    marginTop: "15px"
  },
  cardsTextFloat: {
    color: "rgba(255, 255, 255, 0.5)",
    float: "right"
  },
  cardTitle: {
    color: "rgba(255, 255, 255, 0.5)",
    fontSize: "14px",
    letterSpacing: "2px",
    textTransform: "uppercase"
  }
});

const DataCards = ({ data, dataType }) => {
  const classes = useStyles();

  return (
    <CardContent classes={{ root: classes.main }}>
      <Typography variant="h2" className={classes.cardTitle}>
        {dataType.title}
        <div className={classes.cardsTextFloat}>
          <MoreVertIcon />
        </div>
      </Typography>
      <Typography variant="h2" className={classes.cardsText}>
        {data ? (
          <React.Fragment>
            {data.toFixed(dataType.toFixed)}
            {dataType.measurement}
          </React.Fragment>
        ) : (
          "-"
        )}
      </Typography>
    </CardContent>
  );
};

export default DataCards;
